<template>
	<div class="panel_sale">
		<div class="list" v-if="type==='list'"> 
			<yajinList></yajinList>
		</div>
		<div class="add" v-if="type==='add'">
			<yajin></yajin>
			<!-- <div class="settlementBox">
				<ximeiSettlement></ximeiSettlement>
			</div> -->
		</div>
	</div>
</template>
<script>
	import yajin from "./comp/yajin.vue"
	import yajinList from "./comp/yajin_list.vue"
	export default {
		components:{yajin,yajinList},
		data(){
			return{
				
			}
		},
		computed:{
			type(){
				return this.$store.state.yajin.type;
			}
		},
		mounted(){
			
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	position: relative;
	width:100%;
	height: 100%;
	.settlementBox{
		position: absolute;
		z-index: 11;
		bottom:0;
		width:100%;
	}
	.list{
		height: 100%;
	}
	.add{
		height: 100%;
	}
}
</style>
